export default __webpack_public_path__ + "static/media/main_chute.7f6f68b8.png";